import React from 'react';
import EnsLoader from './EnsLoader';

/**
 * In-content placeholder while a route chunk loads. The app shell (sidebar,
 * header, section nav) stays on screen; only the page area shows the loader.
 * The full-screen boot splash is reserved for the initial auth check.
 */
const RouteLoadingFallback: React.FC<{ variant?: 'page' | 'section' }> = ({ variant = 'page' }) => (
  <EnsLoader style={variant === 'page' ? { minHeight: 320 } : undefined} />
);

export default RouteLoadingFallback;
